import { random } from 'lodash';

export default function favicon(customFavicon) {
    if (customFavicon) {
        let faviconRef = document.querySelector('link[rel="shortcut icon"]');
        const versionedLink = link => `${link}?v=${random(1000)}`;

        if (!faviconRef) {
            const head = document.querySelector('head');
            faviconRef = document.createElement('link');
            faviconRef.setAttribute('rel', 'shortcut icon');
            head.appendChild(faviconRef);
        }

        faviconRef.setAttribute('type', 'img/png');
        faviconRef.setAttribute('href', versionedLink(customFavicon));
    }
}
